import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "src/app/services/api.service";
import { CommonService } from "src/app/services/common.service";


@Component({
  selector: 'fury-payments-table',
  templateUrl: './payments-table.component.html',
  styleUrls: ['./payments-table.component.scss']
})
export class PaymentsTableComponent implements OnInit {

  @Input() displayedColumns: any[];
  @Input() dataSource: any[] = [];
  userId = "";
  @Input() editorAccess:boolean;
  constructor(public commonService: CommonService, private router: Router, private activateRoute: ActivatedRoute, private apiService: ApiService) { }

  ngOnInit(): void {
    this.userId = this.activateRoute.snapshot.params["id"];
  }

  handleEditFeedback(rowData) {
    const reviewId = rowData?.reviewId;
    if (!reviewId || !this.userId) return;
    this.apiService.routeToPage(`customer-dashboard/${this.userId}/feedback-request/${reviewId}`);
  }
  handleViewFeedback(rowData: any) {
    const reviewId = rowData?.reviewId;
    if (!reviewId || !this.userId) return;
    this.apiService.routeToPage(`customer-dashboard/${this.userId}/view-feedback-request/${reviewId}`);
  }

}
